export const PanelLeftOpen = (props: React.SVGProps<SVGSVGElement>) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.341 4.31999V19.68C2.341 20.7404 3.2259 21.6 4.31747 21.6H20.0235C21.1151 21.6 22 20.7404 22 19.68V4.31999C22 3.25961 21.1151 2.39999 20.0235 2.39999H4.31747C3.2259 2.39999 2.341 3.25961 2.341 4.31999ZM4.091 19.68V4.31999C4.091 4.2895 4.10112 4.25465 4.13927 4.21759C4.17832 4.17966 4.23805 4.14999 4.31747 4.14999H8V19.85H10V4.14999H20.0235C20.103 4.14999 20.1627 4.17966 20.2017 4.21759C20.2399 4.25465 20.25 4.2895 20.25 4.31999V19.68C20.25 19.7105 20.2399 19.7453 20.2017 19.7824C20.1627 19.8203 20.103 19.85 20.0235 19.85H4.31747C4.23804 19.85 4.17832 19.8203 4.13927 19.7824C4.10112 19.7453 4.091 19.7105 4.091 19.68Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17.8884 12.1832L17.8904 12.1852L17.2727 12.8029L17.2706 12.8009L13.6172 16.4544L12.341 15.4L15.6529 12.1832L12.341 8.89999L13.6122 7.90706L17.2706 11.5655L17.2777 11.5585L17.8954 12.1762L17.8884 12.1832Z"
			fill="currentColor"
		/>
	</svg>
);
